import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
//import { url } from "../config";
import { getAuthClient } from "../utils/auth";
import Navbar from "./layout/Navbar";
import Screens from "./screens/Screens";
import Screen from "./screens/Screen";
import About from "./pages/About";
import "../App.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logo from "../logo.svg";

const auth = getAuthClient();

/**
 * Helper function to validate data retrieved from JSON:API.
 */
function isValidData(data) {
  if (data === null) {
    return false;
  }
  if (data.data === undefined || data.data === null || data.data.length === 0) {
    return false;
  }
  return true;
}

const Landing = ({ onLogout }) => {
  const [screens, setScreens] = useState([]);
  const [screen, setScreen] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch Screens
    setLoading(true);

    //const url = `/jsonapi/node/screen?sort=title&filter[status][value]=1`
    const url = `/jsonapi/node/screen?sort=title&filter[status][value]=1&include=field_playlist_reference.field_playlist.field_media_image,field_playlist_reference.field_playlist.field_media_video_file&jsonapi_include=1&fields[node--screen]=title,field_playlist_reference&fields[node--playlist]=field_playlist&fields[media--image]=field_media_image,status&fields[file--file]=screen_thumbnail`;

    const headers = new Headers({
      Accept: "application/vnd.api+json",
    });

    auth
      .fetchWithAuthentication(url, { headers })
      .then((response) => response.json())
      .then((data) => {
        if (isValidData(data)) {
          // Initialize the list of content with data retrieved from Drupal.
          setScreens(data.data);
        }
      })
      .catch((err) => console.log("There was an error accessing the API", err));

    setLoading(false);
  }, []);

  // Get single screen
  const getScreen = async (uuid) => {
    //setLoading(true)

    //const url = `/jsonapi/node/screen/${uuid}?include=field_playlist_reference.field_playlist.field_media_image,field_playlist_reference.field_playlist.field_media_video_file&jsonapi_include=1&fields[node--screen]=changed,field_playlist_reference,field_screen_layout,field_screen_message,field_screen_location,field_screen_address&fields[node--playlist]=field_playlist,field_slide_duration&fields[media--image]=field_media_image,status&fields[media--video]=field_media_video_file&fields[file--file]=uri`
    const url = `/jsonapi/node/screen/${uuid}?include=field_playlist_reference.field_playlist.field_media_image,field_playlist_reference.field_playlist.field_media_video_file,field_external_data,field_font&jsonapi_include=1&fields[node--screen]=changed,field_playlist_reference,field_screen_layout,field_screen_message,field_screen_location,field_screen_address,field_tide_location,field_external_data,field_font,field_background_colour,field_text_colour&fields[node--playlist]=field_playlist,field_slide_duration&fields[node--external_data]=field_heading,field_endpoint&fields[taxonomy_term--fonts]=field_font_family,field_font_weight,field_font_style,field_font_text_transform,field_font_letter_spacing&fields[media--image]=field_media_image,status&fields[media--video]=field_media_video_file,status&fields[file--file]=uri`;

    const headers = new Headers({
      Accept: "application/vnd.api+json",
    });

    auth
      .fetchWithAuthentication(url, { headers })
      .then((response) => response.json())
      .then((data) => {
        if (isValidData(data)) {
          // Initialize the list of content with data retrieved from Drupal.
          setScreen(data);
        }
      })
      .catch((err) => console.log("There was an error accessing the API", err));

    //setLoading(false)
  };

  return (
    <Router>
      <Switch>
        <Route
          exact
          path="/screen/:id"
          render={(props) => <Screen {...props} getScreen={getScreen} screen={screen} />}
        />
        <>
          <div className="App">
            <div className="topbar">
              <img src={logo} alt="InScreen" />
            </div>
            {/* <div className='maincontent'> */}
            <div className="container">
              <Route exact path="/" render={() => <Screens loading={loading} screens={screens} />} />
              <Route exact path="/about" component={About} />
            </div>
            {/* </div> */}
          </div>
          <Navbar onLogout={onLogout} />
        </>
      </Switch>
    </Router>
  );
};

export default Landing;
